import React, { Component } from 'react';

class Resume extends Component {
  render() {

    if(this.props.data){
      var education = this.props.data.education.map(function(education){
        return (
        <div key={education.school + education.degree + education.graduated + education.thesissupervisor}>
          <div key={education.school}>
            <h3>{education.school}</h3>
          <div key={education.degree + education.graduated} className="info">
            {education.degree} <span>&bull;</span><em className="date">{education.graduated}</em>
          </div>
          {education.thesistitle ? <div><i>Thesis title:</i> {education.thesistitle}</div> : null}
          {education.thesissupervisor ? <div><i>Supervisor:</i> {education.thesissupervisor}</div> : null }
          </div>
        </div>)
      })
      var work = this.props.data.work.map(function(work){
        return <div key={work.company}><h3>{work.company}</h3>
            <p className="info">{work.title}<span>&bull;</span> <em className="date">{work.years}</em></p>
            <p>{work.description}</p>
        </div>
      })
    }

    return (
      <section id="resume">

      <div className="row education">
         <div className="three columns header-col">
            <h1><span>Education</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                 {education}
               </div>
            </div>
         </div>
      </div>


      <div className="row work">

         <div className="three columns header-col">
            <h1><span>Work</span></h1>
         </div>

         <div className="nine columns main-col">
          {work}
        </div>
      </div>



      <div className="row skill">

        <div className="three columns header-col">
          <h1><span>Programming</span></h1>
        </div>

        <div className="nine columns main-col">
          C++, Sage (Python)
			  </div>
      </div>
   </section>
    );
  }
}

export default Resume;
